window.app = window.app || {};

window.app.riw = {
  el: {
    carousel: document.querySelector('.mt-riw__carousel .swiper'),
    pods: document.querySelectorAll('.mt-pods-item')
  },

  switchActivePod: function(pod = null) {
    if (pod === null) return;

    const _this = this;
    const relatedSlide = _this.slider.slides.filter(slide => slide.dataset.id === pod.dataset.id);
    const relatedSlideId = (relatedSlide.length > 0) ? _this.slider.slides.indexOf(relatedSlide[0]) : null;
    _this.slider.slideTo(relatedSlideId);
  },

  init: function() {
    const _this = this;
    if (!_this.el.carousel) return;

    _this.slider = new Swiper(_this.el.carousel, {
      slidesPerView: 1,
      spaceBetween: 16,
      loop: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false
      },
      pagination: {
        el: '.mt-riw__pagination',
        clickable: true
      },
      navigation: {
        nextEl: '.mt-riw__arrow--next',
        prevEl: '.mt-riw__arrow--prev',
      },
      breakpoints: {
        992: {
          autoplay: false
        }
      }
    });
    _this.slider.on('slideChange', function () {
      const slideId = _this.slider.slides[_this.slider.activeIndex].dataset.id;
      const relatedPod = document.querySelector(`.mt-pods-item[data-id="${slideId}"]`);
      _this.el.pods.forEach(pod => pod.classList.remove('active'));
      relatedPod && relatedPod.classList.add('active');
    });
    _this.slider.slidePrev(0);
    _this.slider.slideNext(0);
    _this.slider.slideTo(0);

    // Pods control
    _this.el.pods.forEach(pod => {
      pod.addEventListener('click', () => {
        if (window.innerWidth >= 992) return;
        _this.switchActivePod(pod);
      });
      pod.addEventListener('mouseenter', () => {
        if (window.innerWidth <= 991) return;
        _this.switchActivePod(pod);
      });
      pod.addEventListener('mouseleave', () => {
        if (window.innerWidth <= 991) return;
        setTimeout(() => pod.classList.remove('active'), 1000);
      });
    });
  }
}
window.app.riw.init();